import SpecCategoryDetail from "../models/SpecCategoryDetail";
import {
  initDataComponent,
  performRetrieveListRequest,
} from "./dataComponentActions";

export const specCategoryDetailsDataComponentId =
  "SpecCategoryDetailsDataComponentId";

export function retrieveSpecCategoryDetails(specCategoryId) {
  return dispatch => {
    dispatch(
      initDataComponent(
        specCategoryDetailsDataComponentId,
        SpecCategoryDetail,
        [],
        "spec-category-details",
        true,
        "v2"
      )
    );

    dispatch(
      performRetrieveListRequest(specCategoryDetailsDataComponentId, {
        rootFilters: {
          $where: {
            specCategoryId: specCategoryId,
          },
        },
        sort: [{ columnName: "name", direction: "asc" }],
        pageSize: -1,
      })
    );
  };
}
